import { IConstantVT } from "./types/constant";

// 素材类型
export const UI_TYPE: IConstantVT = {
  IMAGE: {
    value: 1,
    text: '单图',
  },
  VIDEO: {
    value: 2,
    text: '视频',
  },
  AUDIO: {
    value: 3,
    text: '音频',
  },
  GROUP_PIC: {
    value: 4,
    text: '组图',
  },
  SCRIPT: {
    value: 5,
    text: '脚本',
  },
};

// 素材规格类型
export const MATERIAL_SPEC_TYPE = {
  IMAGE_HORIZONTAL: {
    value: 'IMAGE_HORIZONTAL',
    text: '横版图片',
  },
  IMAGE_VERTICAL: {
    value: 'IMAGE_VERTICAL',
    text: '竖版图片',
  },
  IMAGE_SQUARE: {
    value: 'IMAGE_SQUARE',
    text: '方图',
  },
  IMAGE_GROUP: {
    value: 'IMAGE_GROUP',
    text: '组图',
  },
  VIDEO_HORIZONTAL: {
    value: 'VIDEO_HORIZONTAL',
    text: '横版视频',
  },
  VIDEO_VERTICAL: {
    value: 'VIDEO_VERTICAL',
    text: '竖版视频',
  },
}

// 素材状态
export const MATERIAL_STATUS: IConstantVT = {
  VALID: {
    value: 1,
    text: '有效',
    color: '#15D196',
  },
  INVALID: {
    value: 0,
    text: '无效',
    color: '#999999',
  },
  NOT_VALID_PERIOD: {
    value: 2,
    text: '未开放',
    color: '#d7d5d5ff',
  },
};

// 素材审核状态
export const MATERIAL_AUDIT_STATUS: IConstantVT = {
  SUCCESS: {
    value: 1,
    text: '审核成功',
    color: '#15D196',
    bgColor: '#94C86C1A',
    iconColor: '#94C86C'
  },
  FAIL: {
    value: 2,
    text: '审核失败',
    color: '#DB3543',
    bgColor: '#D345351A',
    iconColor: '#D34535'
  },
  WAIT: {
    value: 3,
    text: '审核中',
    color: '#EEBF55',
    bgColor: '#EEBF551A',
    iconColor: '#EEBF55'
  },
};

// 原始素材筛选项字段operate类型
export const MATERIAL_FILTER_OPERATE_TYPE = {
  EQUALS: {
    value: 'OPERATOR_EQUALS',
    text: '等于',
  },
  LIKE: {
    value: 'OPERATOR_LIKE',
    text: '模糊匹配',
  },
  LESS_EQUALS: {
    value: 'OPERATOR_LESS_EQUALS',
    text: '小于等于',
  },
  LESS: {
    value: 'OPERATOR_LESS',
    text: '小于',
  },
  GREATER_EQUALS: {
    value: 'OPERATOR_GREATER_EQUALS',
    text: '大于等于',
  },
  GREATER: {
    value: 'OPERATOR_GREATER',
    text: '大于',
  },
  IN: {
    value: 'OPERATOR_IN',
    text: '包含',
  },
  NOT_IN: {
    value: 'OPERATOR_NOT_IN',
    text: '不包含',
  },
  NOT_EQUALS: {
    value: 'OPERATOR_NOT_EQUALS',
    text: '不等于',
  },
  BETWEEN: {
    value: 'OPERATOR_BETWEEN',
    text: '范围之内',
  },
};

// 素材来源
export const MATERIAL_SOURCE = {
  AMS_MUTUAL: {
    value: 10,
    text: 'AMS互选素材',
  },
}

// 原始素材筛选项字段
export const MATERIAL_FILTER_FIELDS: {
  [key: string]: {
    value: string;
    title: string;
    operators: {
      value: string;
      text: string;
    }[];
    type: string;
    options?: IConstantVT;
    fieldType: 'string' | 'number';
    placement?: string;
    needSplit?: boolean;

  }
} = {
  ID: {
    value: 'id',
    title: '素材ID',
    operators: [
      MATERIAL_FILTER_OPERATE_TYPE.IN
    ],
    type: 'input',
    fieldType: 'number',
    placement: '多个ID用空格隔开',
    needSplit: true
  },
  UI_TYPE: {
    value: 'ui_type',
    title: '素材类型',
    operators: [
      MATERIAL_FILTER_OPERATE_TYPE.IN
    ],
    type: 'multi_select',
    options: UI_TYPE,
    fieldType: 'number'
  },
  SPEC: {
    value: 'spec',
    title: '素材规格',
    operators: [
      MATERIAL_FILTER_OPERATE_TYPE.IN
    ],
    type: 'multi_select',
    options: MATERIAL_SPEC_TYPE,
    fieldType: 'string'
  },
  STATUS: {
    value: 'status',
    title: '素材状态',
    operators: [
      MATERIAL_FILTER_OPERATE_TYPE.EQUALS,
    ],
    type: 'select',
    options: MATERIAL_STATUS,
    fieldType: 'number'
  },
  TITLE: {
    value: 'title',
    title: '素材标题',
    operators: [
      MATERIAL_FILTER_OPERATE_TYPE.LIKE,
    ],
    type: 'input',
    fieldType: 'string'
  },
  DESCRIPTION: {
    value: 'description',
    title: '素材描述',
    operators: [
      MATERIAL_FILTER_OPERATE_TYPE.LIKE,
    ],
    type: 'input',
    fieldType: 'string'
  },
  SCRIPTS: {
    value: 'scripts',
    title: '素材脚本',
    operators: [
      MATERIAL_FILTER_OPERATE_TYPE.LIKE,
    ],
    type: 'input',
    fieldType: 'string'
  },
  // SUMMARY: {
  //   value: 'summary',
  //   title: '素材摘要',
  //   operators: [
  //     MATERIAL_FILTER_OPERATE_TYPE.LIKE,
  //   ],
  //   type: 'input',
  //   fieldType: 'string'
  // },
  // CONTENTTYPE: {
  //   value: 'contenttype',
  //   title: '内容分类',
  //   operators: [
  //     MATERIAL_FILTER_OPERATE_TYPE.LIKE,
  //   ],
  //   type: 'input',
  //   fieldType: 'string'
  // },
  // TAG_LIST: {
  //   value: 'taglist',
  //   title: '内容tag信息',
  //   operators: [
  //     MATERIAL_FILTER_OPERATE_TYPE.LIKE,
  //   ],
  //   type: 'input',
  //   fieldType: 'string'
  // },
  // FEATURE: {
  //   value: 'feature',
  //   title: '素材范式',
  //   operators: [
  //     MATERIAL_FILTER_OPERATE_TYPE.LIKE,
  //   ],
  //   type: 'input',
  //   fieldType: 'string'
  // },
  // SUITE_CHANNEL: {
  //   value: 'suite_channel',
  //   title: '动态渠道归类 ',
  //   operators: [
  //     MATERIAL_FILTER_OPERATE_TYPE.LIKE,
  //   ],
  //   type: 'input',
  //   fieldType: 'string'
  // },
  WIDTH: {
    value: 'width',
    title: '素材宽度 ',
    operators: [
      MATERIAL_FILTER_OPERATE_TYPE.EQUALS,
    ],
    type: 'input',
    fieldType: 'number'
  },
  HEIGHT: {
    value: 'height',
    title: '素材高度 ',
    operators: [
      MATERIAL_FILTER_OPERATE_TYPE.EQUALS,
    ],
    type: 'input',
    fieldType: 'number'
  },
  FILENAME: {
    value: 'filename',
    title: '文件名',
    operators: [
      MATERIAL_FILTER_OPERATE_TYPE.LIKE,
    ],
    type: 'input',
    fieldType: 'string'
  },
  MD5: {
    value: 'material_md5',
    title: 'md5',
    operators: [
      MATERIAL_FILTER_OPERATE_TYPE.LIKE,
    ],
    type: 'input',
    fieldType: 'string',
    placement: '多个md5用空格隔开',
    needSplit: true
  },
  CREATE_USER: {
    value: 'create_user',
    title: '创建人',
    operators: [MATERIAL_FILTER_OPERATE_TYPE.EQUALS],
    type: 'select',
    options: Object.entries(JSON.parse(sessionStorage.getItem('spaceEmployeeList') || '{}')).reduce((acc, [key, value]) => ({
      ...acc,
      [key]: {
        value: key,
        text: value,
      }
    }), {}),
    fieldType: 'string'
  },
  CREATOR_ORG_ID: {
    value: 'creator_org_id',
    title: '所属组织',
    operators: [MATERIAL_FILTER_OPERATE_TYPE.EQUALS],
    type: 'select',
    options: Object.entries(JSON.parse(sessionStorage.getItem('spaceOrgList') || '{}')).reduce((acc, [key, value]) => ({
      ...acc,
      [key]: {
        value: key,
        text: value,
      }
    }), {}),
    fieldType: 'string'
  },
  CREATE_TIME: {
    value: 'create_time',
    title: '创建时间',
    operators: [
      MATERIAL_FILTER_OPERATE_TYPE.BETWEEN,
      MATERIAL_FILTER_OPERATE_TYPE.EQUALS,
    ],
    type: 'between',
    fieldType: 'string',
    options: {
      RECENT_1_DAY: {
        value: '1',
        text: '近1天',
      },
      RECENT_7_DAYS: {
        value: '7',
        text: '近7天',
      },
    },
  },
  SOURCE: {
    value: 'source',
    title: '素材来源',
    operators: [
      MATERIAL_FILTER_OPERATE_TYPE.EQUALS,
    ],
    type: 'select',
    options: MATERIAL_SOURCE,
    fieldType: 'number'
  },
  IS_UNIVERSAL: {
    value: 'is_universal',
    title: '公共素材',
    operators: [
      MATERIAL_FILTER_OPERATE_TYPE.EQUALS,
    ],
    type: 'select',
    options: {
      YES: {
        value: 1,
        text: '是',
      },
      NO: {
        value: 0,
        text: '否',
      }
    },
    fieldType: 'number'
  }
};

// 素材额外信息
export const EXTRA = {
  SAAS_ID: {
    value: 'saas_id',
    text: 'saas脚本ID',
  },
  TAG_LIST: {
    value: 'taglist',
    text: '内容tag信息',
  },
  FEATURE: {
    value: 'feature',
    text: '素材范式',
  },
  CONTENTTYPE: {
    value: 'contenttype',
    text: '内容分类',
  },
  SUITE_CHANNEL: {
    value: 'suite_channel',
    text: '动态渠道归类 ',
  },
  SUMMARY: {
    value: 'summary',
    text: '摘要',
  },
}
